import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@styles/global.css";

export const wrapRootElement = ({ element }) => element;
